import ExportToExcel from './ExportToExcel';
import ReportTable from './ReportTable';
import './StatisticsInformationModal.css';
import CloseIcon from './images/close-message.svg';

function StatisticsTable({ setFullScreenTable }) {
  return (
    <div className="statistics-table">
      <div
        className="statistics-table-shadow"
        onClick={() => setFullScreenTable(false)}
      ></div>

      <div className="statistics-table-container">
        <div className="statistics-table-header">
          <div>Tabela kvarova</div>

          <div className="statistics-table-icons">
            <ExportToExcel height={40} />

            <img
              height={18}
              src={CloseIcon}
              alt=""
              className="stats-switch"
              onClick={() => setFullScreenTable(false)}
            />
          </div>
        </div>
        <div className="statistics-table-body">
          <ReportTable setFullScreenTable={setFullScreenTable} />
        </div>
      </div>
    </div>
  );
}

export default StatisticsTable;
